import { render, staticRenderFns } from "./AppConfig.vue?vue&type=template&id=6166c9f3&"
import script from "./AppConfig.vue?vue&type=script&lang=js&"
export * from "./AppConfig.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports